import React, {useState, useEffect} from "react";
import { alertResponseMessage } from "../../actions/action-creators/response";
import { post_api_call, error_api_call } from "../../actions/action-creators/common";
import FormDataPinStu from "../../data/formData/student/students";
import ValidationHelper from "../../helper/validation";
import ModalMaster from "../master";
const {
    fieldValidPinStu,
    fieldPinStu
} = FormDataPinStu;
// fieldValidPinStuStatus

function PinTopModal(props) {
    const { data } = props;
    const [userData, setUserData] = useState({user_id: '',
                                            title: '',
                                            // user_readonly: false
                                        });
    const [isProcess, setIsProcess] = useState(false);
    const [errorData, setErrorData] = useState([]);
    const [formData, setFormData] = useState(fieldPinStu);

    useEffect(() => {
        if(typeof props.data !== "undefined"
            && typeof props.data.user_id !== "undefined"
        ){
            setUserData({
                // user_id: (typeof props.data !== "undefined" && typeof props.data.id !== "undefined") ? props.data.id : '',
                user_id: props.data.user_id,
                title: (props.data && props.data.top_deck_title) ? props.data.top_deck_title : '',
                // user_readonly: true
            });
            try{
                var currentFormData = fieldPinStu;
                fieldPinStu[0].readonly =  props.data.user_id ? true : false;
                setFormData([...currentFormData]);
            }catch(e){

            }
        }
    }, [data]);// eslint-disable-line react-hooks/exhaustive-deps
    //Update Input
    const updateInput = (field, value) => {
        try{
            var updatedFormDetails = {...userData};
            updatedFormDetails[field] = value;
            setUserData({...updatedFormDetails});
        }catch(e){
          console.log(e)
        }
    }
    const _submitForm = async(e) => {
        try{
            e.preventDefault();
            setIsProcess(true);
            setErrorData([]);
            //Validation
            const validation = ValidationHelper.validation(userData, fieldValidPinStu).error;
            if(validation.length){
                setErrorData(validation);
                setIsProcess(false);
                return;
            }
            const apiData = await post_api_call(`pin-student/add-update`, userData);
            if(apiData.status === 200){
                alertResponseMessage({alert_type: 1, message: "Details Submitted Successfully"});
                props._toggleModal(e, false);
                //Return to asked function
                if(props.modal_type === 'main'){
                    props._afterUpdate();
                }
            }
            setIsProcess(false);
        }catch(error){
            setIsProcess(false);
            console.error(error);
            alertResponseMessage({alert_type: 2, message: "Error Submitting! Please try after some times"});
            error_api_call({error: `modal/student/pin-top|_submitForm|${e}`});
        }
    }

    return (
      <>
        <ModalMaster
            isShow={props.isShow}
            _toggleModal={(e, state) => props._toggleModal(e, state)}
            // modKey={activeEditForm}//new, edit
            formType={'add_update'}
            data={userData}
            title={"Top Deck/Pinned Student Details"}
            _errorData={{add_update: errorData}}
            _isProcess={{add_update: isProcess}}
            _updateInput= {(form_type, variable_type, input_type, field, value) => updateInput(field, value)}
            _submitForm={(e, form_type) => _submitForm(e)}
            _formData={[{form_type: 'add_update', label: 'Details', fields: [...formData]}]}
        />
        {/* <Modal dialogClassName="modal-70w" show={props.isShow||false} onHide={(e) => props._toggleModal(e, false)} backdrop="static" keyboard={false} className="mod-custom team-detail">
          <Modal.Header closeButton>
              <Modal.Title>Top Deck/Pinned Student Details</Modal.Title>
          </Modal.Header>
          <Modal.Body className="table-detail team-detail">
            <div className="scroll-div">
                <fieldset>
                    <legend>Details</legend>
                    <div className="row m-0">
                        <div className="col-md-12 col-12">
                            <div className="mb-4">
                                <label className="form-label">User Id<em className="required">*</em></label>
                                <input type="number" className="form-control" id="user_id" name="user_id" placeholder="" value={userData.user_id} onChange={(e) => updateInput('user_id', e.target.value)} min={1} readOnly={userData.user_readonly}/>
                            </div>
                        </div>
                        <div className="col-md-12 col-12">
                            <div className="mb-4">
                                <label className="form-label">Title<em className="required">*</em></label>
                                <textarea className="form-control" id="title" name="title" placeholder="" value={userData.title} onChange={(e) => updateInput('title', e.target.value)} rows={2}></textarea>
                                <CharacterCount
                                    max={100}
                                    string={userData.title}
                                />
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>
          </Modal.Body>
          <Modal.Footer className="justify-content-center">
          <div className="row">
            <div className="col-md-12 col-12">
            {(errorData.length > 0) && (
                <div className="alert alert-danger mt-4" role="alert">
                    <p>Please enter/modify following Data:</p>
                    <ol>
                    {errorData.map((error, error_index) => (
                        <li key={`error_${error_index}`}>{error}</li>
                    ))}
                    </ol>
                </div>
            )}
            </div>
            <div className="col-md-12 col-12">
                <button className="btn btn-secondary" disabled={props.isProcess} onClick={(e) => props._toggleModal(e, false)}>Close</button>
                <p className="text-center">
                    {!isProcess
                    ?
                        <button className="btn btn-primary bg-color-blue" type="submit" onClick={(e) => _submitForm(e)}><span className="fs-6">Submit</span></button>
                    :
                        <button className="btn btn-primary bg-color-blue" disabled type="submit"><img className="loader" src={require('../../assets/images/Image-Loader.gif')} alt="Loader" /> <span className="fs-6">Submitting...</span></button>
                    }
                </p>
            </div>
            </div>
          </Modal.Footer>
      </Modal> */}
      </>
    );
}
  
export default PinTopModal;